/**
 * 文字列シードから決定論的な乱数を作る（依存パッケージを増やさないための自前実装）
 *
 * デモデータは「同じ現場・スケジュール・日付なら、いつ開いても同じ結果」でないと、
 * 現場ごとの実施率の傾向が再読み込みのたびにブレて、デモの説明が成り立たなくなる。
 * そのため Math.random は使わない。
 */

/** FNV-1a (32bit)。文字列を 0 以上 2^32 未満の整数に写す */
export const hashString = (text: string): number => {
  let hash = 0x811c9dc5
  for (let index = 0; index < text.length; index++) {
    hash ^= text.charCodeAt(index)
    hash = Math.imul(hash, 0x01000193)
  }
  return hash >>> 0
}

/**
 * mulberry32 の出力段。
 * FNV-1a の値をそのまま 0〜1 にすると、日付だけが違うシードで偏るため、ここで混ぜ直す。
 */
const mix = (seed: number): number => {
  let t = (seed + 0x6d2b79f5) | 0
  t = Math.imul(t ^ (t >>> 15), t | 1)
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296
}

/** 文字列シードから [0, 1) の乱数を返す。同じシードなら常に同じ値 */
export const seededRandom = (seed: string): number => mix(hashString(seed))
